import React from "react";
import { useI18n } from "../i18n/I18nProvider";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

export default function FAQ() {
  const { t } = useI18n();
  return (
    <section id="faq" className="relative py-24 sm:py-32 bg-[#050505]" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="text-[11px] tracking-[0.35em] uppercase font-bold text-scooter-yellow mb-3">{t.faq.label}</div>
          <h2 className="font-heading font-black text-white text-4xl sm:text-5xl tracking-tighter">{t.faq.title}</h2>
        </div>
        <Accordion type="single" collapsible className="w-full">
          {t.faq.items.map((item, i) => (
            <AccordionItem key={item.q} value={`item-${i}`} className="border-white/10" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-white text-left font-heading font-semibold text-lg sm:text-xl hover:text-scooter-yellow hover:no-underline">{item.q}</AccordionTrigger>
              <AccordionContent className="text-zinc-400 leading-relaxed text-base">{item.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
